<tile
  (onClick)="onClick.emit()"
  [active]="active"
  [title]="data?.title"
  [description]="data?.internalTitle"
  [hoverActive]="hoverActive"
>
  <ng-content></ng-content>
</tile>
